import React from 'react';

const AddOrEditCafe = React.createContext();

export default AddOrEditCafe;
